import fetchJsonp from 'fetch-jsonp'

export function inherit(C, P) {
  const F = function () {
  };
  F.prototype = P.prototype;
  C.prototype = new F();
  let i, l, o;
  for (i = 2, l = arguments.length; i < l; i++) {
    o = arguments[i];
    if (typeof o === "function") {
      o = o.prototype;
    }
    extend(C.prototype, o);
  }
}

export function extend(destination, source) {
  destination = destination || {};
  if (source) {
    for (let property in source) {
      let value = source[property];
      if (value !== undefined) {
        destination[property] = value;
      }
    }
    if (source.hasOwnProperty && source.hasOwnProperty("toString")) {
      destination.toString = source.toString;
    }
  }
  return destination;
}

export function Class() {
  const len = arguments.length;
  const P = arguments[0];
  const F = arguments[len - 1];

  const C = typeof F.initialize == "function" ?
    F.initialize :
    function () {
      P.apply(this, arguments);
    };

  if (len > 1) {
    const newArgs = [C, P].concat(
      Array.prototype.slice.call(arguments).slice(1, len - 1), F);
    inherit.apply(null, newArgs);
  } else {
    C.prototype = F;
  }
  return C;
}

// export const Events = Class({
//
//   _listeners: [],
//
//   initialize: function () {
//     this._listeners = [];
//   },
//
//   /**
//    * APIMethod: on Add an event listener
//    *
//    * Parameters: event - {String} Name of the event to listen to callback -
//    * {Function} Function to call when event fired
//    *
//    * Returns: listener - {object} Reference to the listener
//    */
//   on: function (event, callback) {
//     const listener = {event: event, callback: callback};
//     this._listeners.push(listener);
//     return listener;
//   },
//
//   /**
//    * APIMethod: off Remove an event listener
//    *
//    * Parameters: listener - {object} Reference to the listener returned by
//    * addListener
//    */
//   off: function (listener) {
//     for (let i = 0; i < this._listeners.length; i++) {
//       if (this._listeners[i] == listener) {
//         this._listeners.splice(i, 1);
//         break;
//       }
//     }
//   },
//
//   /**
//    * APIMethod: fireEvent Fire an event with a optional number of arguments
//    *
//    * Parameters: event - {String} Name of the event to listen to parameters -
//    * {Object} Optional object parsed to the listener
//    */
//   fireEvent: function (event) {
//     for (let i = 0; i < this._listeners.length; i++) {
//       if (this._listeners[i].event == event) {
//         if (typeof this._listeners[i].callback !== 'undefined') {
//           this._listeners[i].callback.apply(this, arguments);
//         }
//       }
//     }
//   }
// });

export function bind(func, object) {
  // create a reference to all arguments past the second one
  const args = Array.prototype.slice.apply(arguments, [2]);
  return function () {
    // Push on any additional arguments from the actual function call.
    // These will come after those sent to the bind call.
    const newArgs = args.concat(
      Array.prototype.slice.apply(arguments, [0])
    );
    return func.apply(object, newArgs);
  };
}

export async function fetch2(url, options = {}) {
  options.headers = {};
  if (options.data) {
    if (options.method === 'post') {
      options.body = formData(options.data);
      options.headers = {
        'Accept': 'application/json, application/xml, text/play, text/html, *.*',
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
      };
    } else {
      options.headers = {
        'Accept': 'application/json'
      };
      url += (url.indexOf('?') === -1 ? '?' : '&') + queryParams(options.data);
    }
    delete options.data;
  }
  options.headers['Accept'] = 'application/json, application/xml, text/play, text/html, *.*';
  let response = await fetch(url, options);
  return await response.json();
}

function formData(obj) {
  let formData = [];
  Object.keys(obj).forEach((key) => {
    const name = encodeURIComponent(key);
    const value = encodeURIComponent(obj[key]);
    formData.push(name + '=' + value);
  });
  return formData.join('&');
}

export async function fetch3(url, options = {}) {
  if (typeof window === 'undefined') {
    return await fetch2(url, options);
  } else {
    if (options.data) {
      url += (url.indexOf('?') === -1 ? '?' : '&') + queryParams(options.data);
      delete options.data;
    }
    let response = await fetchJsonp(url, options);
    return await response.json();
  }
}

function queryParams(params) {
  return Object.keys(params)
    .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
    .join('&');
}
